module.exports = __webpack_public_path__ + "img/Jim.771bd140.svg";